import { Link } from "react-router-dom";
import { LogoMark } from "@/components/Reveal";
import { ORG } from "@/data/tools";

export const Footer = () => (
  <footer className="bg-brand text-brand-fg">
    <div className="mx-auto max-w-[1400px] px-5 pb-10 pt-20 sm:px-8 lg:px-10">
      <p className="font-display text-[13vw] font-medium leading-[0.85] tracking-[-0.04em] lg:text-[9rem]" aria-hidden="true">
        Accountable<span className="italic text-sun">.</span>
      </p>
      <div className="mt-14 grid gap-10 border-t pt-10 md:grid-cols-4" style={{ borderColor: "color-mix(in srgb, currentColor 25%, transparent)" }}>
        <div className="flex items-start gap-3">
          <LogoMark className="h-11 w-11 shrink-0 rounded-[14px] ring-2 ring-sun" />
          <div>
            <p className="font-display text-xl">The SEND Accountability Project</p>
            <p className="mt-1 opacity-90">SEND Family Hub</p>
          </div>
        </div>
        <div>
          <p className="font-bold">Accessibility</p>
          <p className="mt-2 opacity-90">Built to WCAG 2.2 AA guidance. Use the Accessibility button in the top bar to change text size, background colour, font, spacing and motion, or to hear the page read aloud.</p>
        </div>
        <div className="space-y-1 text-sm" data-testid="footer-company">
          <p className="font-bold">{ORG.name}</p>
          <p className="opacity-90">Supporting schools, families and professionals through practical SEND resources, toolkits and insights.</p>
          <p><a href={`https://${ORG.web}`} target="_blank" rel="noopener noreferrer" className="break-all">{ORG.web}</a></p>
          <p>Requests and enquiries: <a href={`mailto:${ORG.director}`} className="break-all font-bold underline underline-offset-4" data-testid="footer-director-email">{ORG.director}</a></p>
          <p>Data protection: <a href={`mailto:${ORG.datalead}`} className="break-all font-bold underline underline-offset-4" data-testid="footer-datalead-email">{ORG.datalead}</a></p>
          <p><a href={`tel:${ORG.phone.replace(/\s/g, "")}`}>{ORG.phone}</a></p>
          <p>Registered Office: {ORG.office}</p>
          <p>Company No. {ORG.company} | ICO Registration: {ORG.ico}</p>
        </div>
        <nav aria-label="Footer" className="flex flex-col gap-2 font-bold">
          <Link to="/workbook" data-testid="footer-workbook">Quick Start &amp; Improvement Workbook</Link>
          <a href="/#toolkits" data-testid="footer-toolkits">Toolkits</a>
          <Link to="/quick-start" data-testid="footer-quick-start">Toolkit 1: Free Quick Start Pack</Link>
          <a href="/#toolkit-one" data-testid="footer-toolkit-one">Toolkit 2: SENDCO Resource Pack</a>
          <Link to="/toolkit-3" data-testid="footer-toolkit-3">Toolkit 3: Operational Framework</Link>
          <Link to="/toolkit-4" data-testid="footer-toolkit-4">Toolkit 4: School Improvement Planner</Link>
          <Link to="/printables" data-testid="footer-printables">Classroom printables</Link>
          <Link to="/resources" data-testid="footer-resources">Resource directory</Link>
          <Link to="/feedback" data-testid="footer-feedback">Give feedback</Link>
          <Link to="/impact-review" data-testid="footer-impact">One-month review</Link>
          <Link to="/future" data-testid="footer-future">Future developments</Link>
          <Link to="/resource-centre" data-testid="footer-resource-centre">SENDCO Resource Centre</Link>
          <Link to="/poster" data-testid="footer-poster">Quick Start poster</Link>
          <Link to="/contact" data-testid="footer-contact">Contact</Link>
          <Link to="/accessibility" data-testid="footer-accessibility">Accessibility statement</Link>
          <Link to="/privacy" data-testid="footer-privacy">Privacy notice</Link>
          <Link to="/disclaimer" data-testid="footer-disclaimer">Compliance disclaimer</Link>
          <Link to="/admin" className="opacity-90" data-testid="footer-admin">Admin</Link>
        </nav>
      </div>
      <p className="mt-12 text-sm opacity-90">© {new Date().getFullYear()} {ORG.name}. Free to use in schools.</p>
    </div>
  </footer>
);
